module.exports = {
    api: "https://api.clomos.es",
    name: "D&A Innovative Systems",
    publicPath: process.env.NODE_ENV === 'production'
        ? '' // /publicPath
        : ''
}